import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Spinner } from '@vibrent/electryon';
import { useTranslation } from 'react-i18next';
import ExternalModuleFrame from './connectedFrame';
import styles from './styles.scss';
import { EXTERNAL_MODULE_PLACEMENT } from './constants';
import { findModuleByKey, hasPlacement } from './utils';

const CLASS_NAME = styles['external-module-view'];

/**
 * Route component for /externalModule/:moduleKey. Looks the module up in the list fetched
 * for the active program, so a direct page load or refresh lands on the same module once
 * that list has loaded.
 */
const ExternalModuleView = (props) => {
  const { match, history, modules, loaded } = props;
  const { t } = useTranslation();
  const onNavigate = useCallback(path => history.push(path), [history]);

  if (!loaded) {
    return <div className={CLASS_NAME}><div className="module-loading"><Spinner radius={60} /></div></div>;
  }
  const module = findModuleByKey(modules, match.params.moduleKey);
  if (!module || !hasPlacement(module, EXTERNAL_MODULE_PLACEMENT.LEFT_NAV)) {
    return <div className={CLASS_NAME}>{t('This module is not available.')}</div>;
  }
  return (
    <div className={CLASS_NAME}>
      <ExternalModuleFrame
        key={module.url}
        url={module.url}
        title={module.name}
        onNavigate={onNavigate}
      />
    </div>
  );
};

ExternalModuleView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ moduleKey: PropTypes.string }),
  }).isRequired,
  history: PropTypes.shape({ push: PropTypes.func }).isRequired,
  modules: PropTypes.arrayOf(PropTypes.shape({})),
  loaded: PropTypes.bool,
};

ExternalModuleView.defaultProps = {
  modules: [],
  loaded: false,
};

const mapStateToProps = state => ({
  modules: state.ExternalModules.get('modules'),
  loaded: state.ExternalModules.get('loaded'),
});

export default connect(mapStateToProps)(ExternalModuleView);

export const ExternalModuleViewComponent = ExternalModuleView;
